<div>
    <h2>{{'consumos.titulo' | translate}}</h2>
    <div class="filters-info" *ngIf="filtersVisible">{{'global.infoRequired' | translate}}</div>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-warning':showWarning, 'show-error':showError}">
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.pais' | translate}} *</label>
                <app-filterable-list [itemsList]="paises" [selectedItem]="filtersForm.get('pais')"
                    [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.provincia' | translate}}</label>
                <app-filterable-list [itemsList]="provincias" [selectedItem]="filtersForm.get('provincia')"
                    [disabled]="disabledProvincias" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.municipio' | translate}}</label>
                <app-filterable-list [itemsList]="municipios" [selectedItem]="filtersForm.get('municipio')"
                    [disabled]="disabledMunicipios" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.denominacion' | translate}} *</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')"
                [disabled]="disabledDenominaciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.campanya' | translate}} *</label>
                <app-filterable-list [itemsList]="campanyas" [selectedItem]="filtersForm.get('campanya')"
                    [disabled]="disabledCampanya" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.marca' | translate}}</label>
                <app-filterable-list [itemsList]="marcas" [selectedItem]="filtersForm.get('marca')"
                    [disabled]="disabledMarcas" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.etiquetador' | translate}} *</label>
                <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="filtersForm.get('etiquetador')"
                    [disabled]="disabledEtiquetadores" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.almacen' | translate}}</label>
                <app-filterable-list [itemsList]="almacenes" [selectedItem]="filtersForm.get('almacen')"
                    [disabled]="disabledAlmacenes" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="desFinca">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.productor' | translate}}</label>
                <input type="text" formControlName="desProductor">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.lote' | translate}}</label>
                <input type="text" formControlName="lote">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.licencia' | translate}}</label>
                <input type="text" formControlName="licencia">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.confeccion' | translate}}</label>
                <app-filterable-list [itemsList]="confecciones" [selectedItem]="filtersForm.get('confeccion')"
                    [disabled]="disabledConfecciones" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.tipoConfeccion' | translate}}</label>
                <app-filterable-list [itemsList]="tiposConfeccion" [selectedItem]="filtersForm.get('tipoConfeccion')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.destino' | translate}}</label>
                <app-filterable-list [itemsList]="destinos" [selectedItem]="filtersForm.get('paisDestino')" [placeHolder]="false">
                </app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio"
                    (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin"
                    (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.consumo' | translate}}</label>
                <app-filterable-list [itemsList]="tiposConsumo" [selectedItem]="filtersForm.get('consumo')" [placeHolder]="false"></app-filterable-list>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'consumos.filters.codigoSNC' | translate}}</label>
                <input type="text" formControlName="codigoSNC">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <section class="export-buttons">
        <i 
            class="fas fa-file-pdf" 
            [ngClass]="{'disabled': !consumos || (consumos && consumos.length === 0)}"
            title="{{'titles.exportarPDF' | translate}}"
            (click)="exportPdfOrCsv('pdf')"></i>
        <i 
            class="fas fa-file-csv" 
            [ngClass]="{'disabled': !consumos || (consumos && consumos.length === 0)}"
            title="{{'titles.exportarCSV' | translate}}"
            (click)="exportPdfOrCsv('csv')"></i>
        <i class="fa-solid fa-circle-question" (click)="openDocHelp()" title="{{'global.obtenerAyuda' | translate}}"></i>
    </section>
    <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="icon"></th>
                        <!-- <th class="id sortable" (click)="toOrderBy('x=> x.Id', 2)">ID
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.Id', 2)"></i>
                            </div>
                        </th> -->
                        <th class="string sortable" (click)="toOrderBy('x=> x.ConsumosDetalle.FirstOrDefault().Designacion.Cultivo.Finca.Des', 3)">
                            {{'global.finca' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.ConsumosDetalle.FirstOrDefault().Designacion.Cultivo.Finca.Des', 3)"></i>
                            </div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.ConsumosDetalle.FirstOrDefault().Designacion.Cultivo.Finca.Municipio.Des', 5)">
                            {{'global.municipio' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.ConsumosDetalle.FirstOrDefault().Designacion.Cultivo.Finca.Municipio.Des', 5)"></i>
                            </div>
                        </th>
                        <th class="string">
                            {{'consumos.table.productor' | translate}}
                        </th>
                        <th class="string">
                            {{'global.lote' | translate}}
                        </th>
                        <th class="date sortable" (click)="toOrderBy('x=> x.fechaImpresion', 7)">
                            {{'consumos.table.fechaConsumo' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.fechaImpresion', 7)"></i>
                            </div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.Confeccion.Des', 8)">
                            {{'consumos.table.confeccion' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.Confeccion.Des', 8)"></i>
                            </div>
                        </th>
                        <th class="string">
                            {{'global.type' | translate}}
                        </th>
                        <th class="number sortable" (click)="toOrderBy('x=> x.numeroEtiquetasImpresas', 9)">
                            {{'global.unidades' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.numeroEtiquetasImpresas', 9)"></i>
                            </div>
                        </th>
                        <th class="number sortable" (click)="toOrderBy('x=> x.kilosImpresosTotales', 10)">
                            {{'consumos.table.peso' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.kilosImpresosTotales', 10)"></i>
                            </div>
                        </th>
                        <th class="string sortable" (click)="toOrderBy('x=> x.seriadoFijo', 11)">
                            {{'consumos.table.seriadoSNC' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.seriadoFijo', 11)"></i>
                            </div>
                        </th>
                        <!-- <th class="string sortable" (click)="toOrderBy('x=> x.PaisDestino.DesPaisDefecto', 13)">
                            {{'consumos.table.destino' | translate}}
                            <div class="sortable-icons">
                                <i [ngClass]="getIcon('x=> x.PaisDestino.DesPaisDefecto', 13)"></i>
                            </div>
                        </th> -->
                        <th class="actions"></th>
                    </tr>
                </thead>
                <tbody class="clickable" *ngFor="let consumo of consumos; let i=index; trackBy: trackByConsumoId">
                    <tr (click)="showDetails(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
                        <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                            title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="icon">
                            <i *ngIf="consumo.desMarca" class="fa-solid fa-trademark" title="{{'titles.marcaEtiquetada' | translate}}"></i>
                            <i *ngIf="!consumo.denominacionIdUnica" class="fa solid fa-m" title="{{'titles.consumoMix' | translate}}"></i>
                        </td>
                        <!-- <td class="id">{{consumo.id}}</td> -->
                        <td class="string">{{consumo.desFinca}}</td>
                        <td class="string" title="{{consumo.desMunicipio}} ({{consumo.desProvincia}})">{{consumo.desMunicipio}}</td>
                        <td class="string">{{consumo.desProductor}}</td>
                        <td class="string">{{consumo.lote}}</td>
                        <td class="date">{{consumo.fechaImpresion | date:"dd/MM/yyyy H:mm:ss"}}</td>
                        <td class="string">{{consumo.desConfeccion}}</td>
                        <td class="string">{{consumo.tipoConfeccionId === 1 ? ('global.caja' | translate) : consumo.tipoConfeccionId === 2 ? ('global.pallet' | translate) : ''}}</td>
                        <td class="number">{{consumo.numeroEtiquetasImpresas | number : '1.0-0': defaultLanguage}}</td>
                        <td class="number">{{consumo.kilosImpresosTotales | number : '1.2-2': defaultLanguage}}</td>
                        <td class="string">{{consumo.seriadoFijo}}<br>({{('0000' + consumo.seriadoInicio).slice(-4)}} - {{( '0000' + consumo.seriadoFin).slice(-4)}})</td>
                        <!-- <td class="string">{{consumo.desPaisDestinoDefecto}}</td> -->
                        <td class="multi-actions">
                            <i class="fas fa-stream" (click)="showSection(i)" app-click-stop-propagation
                            title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                            <i class="fa-solid fa-print" title="{{'titles.reimpresionesConsumo' | translate}}" [ngClass]="{'disabled': (!consumo.existenReimpresiones || getRolePermission())}" app-click-stop-propagation
                                (click)="showReimpresiones(consumo)"></i>
                            <i class="fa-solid fa-triangle-exclamation" title="{{'titles.incidenciasConsumo' | translate}}" [ngClass]="{'disabled': (!consumo.existenIncidencias || getRolePermission())}" app-click-stop-propagation
                                (click)="showIncidencias(consumo)"></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="12">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline">
                                    <label>{{'consumos.table.id' | translate}}</label>
                                    <p>{{consumo.id}}</p>
                                </div>
                                <div class="block-inline">
                                  <label>{{'consumos.table.denominacion' | translate}}</label>
                                  <p>{{consumo.desDenominacion}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'consumos.table.marca' | translate}}</label>
                                    <p>{{consumo.desMarca ? consumo.desMarca : ('consumos.table.sinMarca' | translate)}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'consumos.table.licencia' | translate}}</label>
                                    <p>{{consumo.nLicencia}}</p>
                                </div>
                                <div class="block-inline">
                                  <label>{{'global.provincia' | translate}}</label>
                                  <p>{{consumo.desProvincia}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'consumos.table.poligono' | translate}}</label>
                                    <p>{{consumo.poligonoCatastral}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'consumos.table.parcela' | translate}}</label>
                                    <p>{{consumo.parcelaCatastral}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'consumos.table.destino' | translate}}</label>
                                    <p>{{consumo.desPaisDestinoDefecto}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'global.fecha.insercionShort' | translate}}</label>
                                    <p>{{consumo.fechaIns | date:"dd/MM/yyyy H:mm:ss"}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'global.fecha.actualizacionShort' | translate}}</label>
                                    <p>{{consumo.fechaUpd | date:"dd/MM/yyyy H:mm:ss"}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'consumos.table.mix' | translate}}</label>
                                    <i *ngIf="!consumo.denominacionIdUnica" class="fa-regular fa-check-circle" title="{{'titles.consumoMix' | translate}}"></i>
                                    <i *ngIf="consumo.denominacionIdUnica" style="color:red" class="fa-regular fa-circle-xmark" title="{{'titles.consumoEstandar' | translate}}"></i>
                                </div>
                                <div class="block-inline"></div>
                                <div class="block-inline"></div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="15">
                          <section class="tabs">
                            <ul>
                              <li [ngClass]="{'active': pestanaActiva[i] === 1}">{{'consumos.table.tabs.confeccion.titulo' | translate}}</li>
                            </ul>
                            <content>
                              <app-confeccion-consumo *ngIf="pestanaActiva[i] === 1" [confeccion]="consumo.confeccion" [mix]="consumo.denominacionIdUnica"></app-confeccion-consumo>
                            </content>
                          </section>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!consumos || (consumos && consumos.length < 1)">
                    <tr>
                        <td colspan="15">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
    <app-paginator *ngIf="consumos && consumos.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
        [totalItems]="totalItems" [visiblePages]="visiblePages" (pageChange)="pageChange($event)"
        (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>
    <app-toast *ngIf="(showError || showWarning) && mensajes" [messages]="mensajes" (closed)="showError=$event;showWarning=$event;">
    </app-toast>
</div>
<div class="modal" *ngIf="reimpresionesModal">
    <div class="modal-content">
        <header>
            <h4>{{'consumos.reimpresiones.titulo' | translate}}</h4>
        </header>
        <app-reimp-consumos class="component" [consumoId]="consumoId" (refresh)="refresh($event)">
        </app-reimp-consumos>
    </div>
</div>
<div class="modal" *ngIf="incidenciasModal">
    <div class="modal-content">
        <header>
            <h4>{{'consumos.incidencias.titulo' | translate}}</h4>
        </header>
        <app-incidencias-consumos class="component" [consumoId]="consumoId" (refresh)="refresh($event)">
        </app-incidencias-consumos>
    </div>
</div>
